import { lang } from "@lib/constants";

export const isUs = () => lang === 'en-us'

export const isUK = () => lang === 'en-gb'

export const isEs = () => lang === 'es-es'
